import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';

const FilterBar = ({ filters, onFilterChange, currentLanguage }) => {
  const translations = {
    en: {
      filterBy: 'Filter By',
      status: 'Status',
      allStatuses: 'All Statuses',
      category: 'Category',
      allCategories: 'All Categories',
      destination: 'Destination',
      allDestinations: 'All Destinations',
      clearFilters: 'Clear Filters'
    },
    ko: {
      filterBy: '필터',
      status: '상태',
      allStatuses: '모든 상태',
      category: '카테고리',
      allCategories: '모든 카테고리',
      destination: '목적지',
      allDestinations: '모든 목적지',
      clearFilters: '필터 초기화'
    }
  };

  const t = translations?.[currentLanguage];

  const statusOptions = [
    { value: '', label: t?.allStatuses },
    { value: 'draft', label: currentLanguage === 'en' ? 'Draft' : '초안' },
    { value: 'active', label: currentLanguage === 'en' ? 'Active' : '활성' },
    { value: 'offered', label: currentLanguage === 'en' ? 'Offered' : '제안됨' },
    { value: 'accepted', label: currentLanguage === 'en' ? 'Accepted' : '수락됨' }
  ];

  const categoryOptions = [
    { value: '', label: t?.allCategories },
    { value: 'electronics', label: currentLanguage === 'en' ? 'Electronics' : '전자제품' },
    { value: 'fashion', label: currentLanguage === 'en' ? 'Fashion & Accessories' : '패션 & 액세서리' },
    { value: 'cosmetics', label: currentLanguage === 'en' ? 'Cosmetics & Beauty' : '화장품 & 뷰티' },
    { value: 'food', label: currentLanguage === 'en' ? 'Food & Beverages' : '식품 & 음료' }
  ];

  const destinationOptions = [
    { value: '', label: t?.allDestinations },
    { value: 'kr', label: currentLanguage === 'en' ? 'South Korea' : '대한민국' },
    { value: 'us', label: currentLanguage === 'en' ? 'United States' : '미국' },
    { value: 'jp', label: currentLanguage === 'en' ? 'Japan' : '일본' },
    { value: 'cn', label: currentLanguage === 'en' ? 'China' : '중국' }
  ];

  const hasActiveFilters = filters?.status || filters?.category || filters?.destination;

  const handleClearFilters = () => {
    onFilterChange({ status: '', category: '', destination: '' });
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-md p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Filter" size={20} color="var(--color-primary)" />
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground">
            {t?.filterBy}
          </h3>
        </div>
        {hasActiveFilters && (
          <button
            onClick={handleClearFilters}
            className="text-sm text-accent hover:text-accent/80 transition-base flex items-center gap-1"
          >
            <Icon name="X" size={16} />
            <span>{t?.clearFilters}</span>
          </button>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Select
          label={t?.status}
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange({ ...filters, status: value })}
        />

        <Select
          label={t?.category}
          options={categoryOptions}
          value={filters?.category}
          onChange={(value) => onFilterChange({ ...filters, category: value })}
        />

        <Select
          label={t?.destination}
          options={destinationOptions}
          value={filters?.destination}
          onChange={(value) => onFilterChange({ ...filters, destination: value })}
        />
      </div>
    </div>
  );
};

export default FilterBar;